const ticketOptionsAdapter = (data) => {
  const { icon } = data;

  return {
    id: data.id,
    name: data.name,
    description: data.description,
    icon: icon && {
      id: icon.id,
      original: icon.original,
    },
  };
};

export const ticketAdapter = (data) => {
  const { group } = data;

  return {
    id: data.id || data.ID,
    class: data.class,

    groupId: data.group_id,
    group: group && {
      id: group.id,
      name: group.name,
    },

    price: data.price, // currencies object { cad: 25.15 }
    childPrice: data.child_price,
    totalPrice: data.total_price,
    remains: data.remains,

    description: data.description,
    photos: data.photos?.map((photo) => ({
      id: photo.id,
      original: photo.original,
    })),
    options: data.options?.map(ticketOptionsAdapter),
  };
};
